export default __webpack_public_path__ + "static/media/noThumbImage.9837b1bf.png";